/** @jsxImportSource @emotion/react */

import { useQuery } from '@apollo/client'
import { findAllUpgradePage, findAllUpgradePageVariables } from '__generatedTypes__/findAllUpgradePage'
import { FIND_ALL_UPGRADE_PAGES } from 'queries/upgradePage'
import { Loader } from 'components/Loader'
import withPlatformCheck from 'HOCs/withPlatformCheck'
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { Form } from './Form'
import { getUpgradePageQueryVariables } from './getUpgradePageQueryVariables'
import * as classes from './styles'

type Props = {
  isForNewUsers?: boolean
  platform: Platform
}

export const ProductPricing = withPlatformCheck(({ isForNewUsers, platform }: Props) => {
  const { data, loading } = useQuery<findAllUpgradePage, findAllUpgradePageVariables>(FIND_ALL_UPGRADE_PAGES, {
    variables: getUpgradePageQueryVariables(platform.id, !!isForNewUsers),
  })

  const renderForms = () =>
    data?.findAllUpgradePage?.items.map((upgradePage) => <Form data={upgradePage} key={upgradePage.id} />)

  if (loading) {
    return <Loader />
  }

  return <div css={classes.container}>{renderForms()}</div>
})
